import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { Flex, Box } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import { iconThemes } from "ui-components/theme";
import Spinner, { styles } from "components/Spinner";
import { gotoUrl, getChannelFromUrl } from "utils/helpers";
import { SELF_ACTIVATION_SIM, paths } from "utils/constants";
import CheckboxField from "components/FormFields/CheckboxField";

const WalletForm = ({
  postPaymentRequest,
  clearPaymentRequest,
  isCreatingOrder,
  order,
  formValues,
  isFetchingPaymentRequest,
  token,
  data,
  checkboxStyles,
  canRequestPayment,
  deliveryDetailsItems,
  orderParams,
  personalDetailFormsValues,
  ...props
}) => {
  useEffect(() => {
    clearPaymentRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sharedWallet = JSON.parse(localStorage.getItem("sharedWallet") || false);

  const loading = isEmpty(order) || isCreatingOrder || isFetchingPaymentRequest;
  const order_ref = get(order, "order_ref");
  console.log("ORDERS", order)
  const channel = getChannelFromUrl();
  const orderSummaryPath = paths.ORDER_SUMMARY.replace(":channel", channel);
  const paymentReturnPath =
    channel === SELF_ACTIVATION_SIM
      ? paths.SUCCESS.replace(":channel", channel)
      : paths.PAYMENT_RETURN.replace(":channel", channel);
  const buttonColor = iconThemes.black;
  const confirmWalletPayment = () => {
    localStorage.removeItem("sharedWallet");
    const return_url = `${window.location.origin}${paymentReturnPath}`;
    const failure_url = return_url;
    const cancel_url = `${window.location.origin}${orderSummaryPath}`;
    const paymentRequestParams = {
      order_id: order_ref,
      token,
      return_url,
      failure_url,
      cancel_url,
      payment_methods: {
        additional_data: {
          custom_payment_method: "wallet"
        }
      }
    };
    postPaymentRequest(paymentRequestParams, (response, error) => {
      if (!error && !isEmpty(response)) {
        gotoUrl(paymentReturnPath, true, { order_ref, token }, true);
      }
    });
  };

  const paymentButtonStyle = {
    marginTop: "18px",
    width: "100%",
    color: "#fff",
    backgroundColor: buttonColor,
    borderColor: buttonColor,
    display: "inline-block",
    fontWeight: "500",
    lineHeight: "1.25",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    cursor: "pointer",
    userSelect: "none",
    border: "1px solid",
    padding: "0.5rem 1rem",
    fontSize: "1.25rem",
    height: "50px",
    borderRadius: "0.25rem"
  };
  const walletTermsAgreed = get(
    formValues,
    "wallet_terms_and_conditions_agreed"
  );
  return (
    <Flex flexDirection="column">
      <Flex>
        <Box px={0}>
          <CheckboxField
            {...props}
            sx={checkboxStyles}
            required={true}
            field="wallet_terms_and_conditions_agreed"
            label={sharedWallet ? "shared_wallet_terms_of_service_agreed" : "wallet_terms_of_service_agreed"}
          />
        </Box>
      </Flex>
      <Flex width={["100%", "80%", "70%"]} mb={3} mx={"auto"}>
        <Box width={"100%"}>
          <button
            disabled={!walletTermsAgreed || loading || !canRequestPayment}
            id="submit"
            data-testid="wallet-pay-button"
            className="wallet-pay-button"
            style={paymentButtonStyle}
            onClick={confirmWalletPayment}
          >
            <Flex
              id="button-text"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
            >
              {loading ? (
                <Spinner size={19} sx={styles.button} />
              ) : (
                <FormattedMessage id={"payment.confirm"} />
              )}
            </Flex>
          </button>
        </Box>
      </Flex>
    </Flex>
  );
};

export default WalletForm;
